import React, { createRef } from 'react';
import Header from './components/header';
import cautaredosare from './assets/cautare-dosare.png';
import cautaredosare2 from './assets/cautaredosare2.png';
import cautaredosare3 from './assets/cautaredosare3.png';
import licitatii from './assets/licitatii.png';
import gcp from './assets/gcp.png';
import study from './assets/study-app.png';
import ebloc1 from './assets/ebloc1.png';
import ebloc2 from './assets/ebloc2.png';
import ebloc3 from './assets/ebloc3.png';
import ebloc4 from './assets/ebloc4.png';
import mtg1 from './assets/mtg1.png';
import mtg2 from './assets/mtg2.png';
import gowebapp from './assets/gowebapp.png';
import left from './assets/left.svg';
import lefth from './assets/left-hover.svg';
import artmedica1 from './assets/artmedica1.png';
import artmedica2 from './assets/artmedica2.png';
import artmedica3 from './assets/artmedica3.png';
import carjoin1 from './assets/carjoin1.png';
import carjoin2 from './assets/carjoin2.png';
import carjoin3 from './assets/carjoin3.png';
import carjoin4 from './assets/car-join.svg';
import ratemy1 from './assets/ratemy1.png';
import ratemy2 from './assets/ratemy2.png';
import ratemy3 from './assets/ratemy3.png';
import ratemy4 from './assets/ratemy4.png';
import timer1 from './assets/timer1.png';
import timer2 from './assets/timer2.png';
import tamato1 from './assets/tamato1.png';
import tamato2 from './assets/tamato2.png';
import tamato3 from './assets/tamato3.png';
import techicon from './assets/tech-icon.svg';
import viewarrow from './assets/view-app-arrow.svg';
import viewarrowh from './assets/view-app-arrow-black.svg';
import aitrading1 from './assets/ai_trading_1.png';
import aitrading2 from './assets/ai_trading_2.png';
import aitrading3 from './assets/ai_trading_3.png';
import aitrading4 from './assets/ai_trading_4.png';
import microflow1 from './assets/microflow_1.png';
import microflow2 from './assets/microflow_2.png';
import microflow3 from './assets/microflow_3.png';
import microflow4 from './assets/microflow_4.png';
import protocol1 from './assets/protocol-1.png';
import protocol2 from './assets/protocol-2.png';
import protocol3 from './assets/protocol-3.png';
import protocol4 from './assets/protocol-4.png';
import protocol5 from './assets/protocol-5.png';
import unfinished1 from './assets/unfinished1.png';
import unfinished2 from './assets/unfinished2.png';
import unfinished3 from './assets/unfinished3.png';
import './case-studies.css';
import './index.css';
import BannerSection from './components/banner';
import Footer from './components/footer';
import HoverImage from "./components/hover-image";
import PageTitle from "./components/page-title";

class ImagePreview extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            project: props.preview.project,
            image: props.preview.project.images[props.preview.project.imageIndex]
        };

        this.handleKeyPress = this.handleKeyPress.bind(this);
    }


    nextImage(event) {
        event.stopPropagation();

        let nextIndex = this.props.preview.project.imageIndex + 1;
        if (nextIndex === this.props.preview.project.images.length) {
            nextIndex = 0;
        } 

        this.props.preview.project.imageIndex = nextIndex;

        this.setState({
            image: this.props.preview.project.images[nextIndex]
        });
    }

    previousImage(event) {
        event.stopPropagation();

        let nextIndex = this.props.preview.project.imageIndex - 1;
        if(nextIndex === -1) {
            nextIndex = this.props.preview.project.images.length - 1
        } 

        this.props.preview.project.imageIndex = nextIndex;
        
        this.setState({
            image: this.props.preview.project.images[nextIndex]
        });
    }

    handleKeyPress(event) {
        console.log("%o", event);
        //debugger;

        if (event.key === 'ArrowRight') {
            this.nextImage(event)
        } else if (event.key === 'ArrowLeft') {
            this.previousImage(event)
        }
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeyPress);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyPress);
    }

    render() {
        

        return (
            <div id='preview' onClick={() => this.props.closeFc(this.props.preview.project, this.props.preview.project.imageIndex)} className="img-preview-back">
                <img className="img-preview-front " alt="big project preview" src={this.state.image} />

                { <div className="left-arrow no-select"><img className="img-arrow show-on-hover-item no-select" src={left} alt="left arrow" onClick={(e) => this.previousImage(e)} /></div> }
                { <div className="right-arrow no-select"><img className="img-arrow show-on-hover-item no-select" src={left} alt="right arrow" onClick={(e) => this.nextImage(e)} /></div> }
            </div>
        )
    }
}

class Project extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            image: this.props.project.images[this.props.project.imageIndex]
        }
    }

    nextImage() {
        let nextIndex = this.props.project.imageIndex + 1;
        if (nextIndex === this.props.project.images.length) {
            nextIndex = 0;
        } 

        this.props.project.imageIndex = nextIndex;

        this.setState({
            image: this.props.project.images[this.props.project.imageIndex]
        });
    }

    previousImage() {
        let nextIndex = this.props.project.imageIndex - 1;
        if (nextIndex === -1) {
            nextIndex = this.props.project.images.length - 1;
        } 

        this.props.project.imageIndex = nextIndex;

        this.setState({
            image: this.props.project.images[this.props.project.imageIndex]
        });
    }

    updateImage(lastImage) {
        this.setState({
            image: this.props.project.images[this.props.project.imageIndex]
        });
    }

    render() {

        return (
            <div className={'project-back background-white show-on-hover' + (!this.props.project.isFirst ? ' project-back-top-border' : '')}>
                
                <div className={`project-content-row`}>
                    
                    <div className='flex-column project-content mr-5'>
                        <div className='project-name t5 mb-2'>{this.props.project.name}</div>
    
                        <div className='project-descriere b2'>{this.props.project.description}</div>
    
                        <div className='project-tehnologies'>
                            { this.props.project.tehnologies.map( (tech, index) => 
                                <div key={index} className='tech'>
                                    <img src={techicon} alt='magenta checkbox' className='mr-1' />
                                    <div className='b2-m'>{tech}</div>
                                </div> 
                            )}
                        </div>

                {this.props.project.url && <div className='project-link  pointer' onClick={() => window.open(this.props.project.url) }>
                    <HoverImage imageA={viewarrow} imageB={viewarrowh} className='mr-1' />
                    <div className='link-text b2-m'>View App</div>
                </div> }

                    </div>
                    
                    
                    <div className={'project-image-outer' + (this.props.project.newDesign ? ' new-design' : '')}>
                        <img className="project-image-inner" alt="project screenshot" src={this.state.image} onClick={() => this.props.onShowPreview()} />
    
                        { this.props.project.images.length > 1 && <div className="left-arrow no-select"><img className="img-arrow show-on-hover-item no-select" src={left} alt="left arrow" onClick={() => this.previousImage()} /></div> }
                        { this.props.project.images.length > 1 && <div className="left-arrow no-select"><img className="img-arrow show-on-hover-item only-on-hover no-select" src={lefth} alt="black left arrow" onClick={() => this.previousImage()} /></div> }

                        { this.props.project.images.length > 1 && <div className="right-arrow no-select"><img className="img-arrow show-on-hover-item no-select" src={left} alt="right arrow" onClick={() => this.nextImage()} /></div> }
                        { this.props.project.images.length > 1 && <div className="right-arrow no-select"><img className="img-arrow show-on-hover-item only-on-hover no-select" src={lefth} alt="black right arrow" onClick={() => this.nextImage()} /></div> }
                    </div>
                    
                </div>

            </div>
        )
    }
}

class CaseStudies extends React.Component {


    constructor(props){
        super(props);

        this.state = {
            preview: {
                project: null,
                imageIndex: 0,
                image: null,
            },
            projects: [
                {
                    name: "AI TRADING BOT",
                    description: "Developed and architected a modular, end-to-end algorithmic trading system designed for automated market analysis, multi-strategy backtesting, optimization, and paper/live execution. The system uses an orchestrator-based microservice architecture to manage workflows ranging from historical data ingestion (Yahoo Finance, Alpha Vantage) and quantitative strategy generation to risk-free paper trading and backtesting via engines like NautilusTrader, Freqtrade, vectorbt, and bt. Integrated multi-process orchestration, structured logging, configuration management, and external API connectors to streamline the pipeline from raw market data to automated execution.", 
                    images: [aitrading1, aitrading2, aitrading3, aitrading4], 
                    imageIndex: 0,
                    tehnologies: ["Telegrom", "Algorithmic Trading", "Microservices", "NautilusTrader", "Vectorbt", "Backtesting" ], 
                    newDesign: false,
                    ref: createRef(),
                    isFirst: true,
                },
                {
                    name: "UNFINISHED",
                    description: `
                    Engineered a cross-platform mobile application utilizing Flutter, adhering to Clean Architecture principles (Framework, Presentation, Application, and Data layers) and use-case-driven patterns.

                    Key features and technical implementations include:
                    - Robust Authentication & Session Management: Integrated secure email verification login flows, automated token refreshing, and persistent local caching using secure storage and state management.
                    - Dynamic Multi-Step Registration Engine: Built complex form submission engines capable of handling dynamic field validation, state synchronization, and conditional progression rules.
                    - Real-Time Push Notifications & Deep Linking: Configured Firebase Cloud Messaging (FCM), APNs integration for iOS, associated domains, and deep link routing to seamless user experiences.
                    `, 
                    images: [unfinished1, unfinished2, unfinished3, ], 
                    imageIndex: 0,
                    tehnologies: ["Push Notifications", "Cross-Platform", "Firebase", "Apple Store", "Google Play Store" ], 
                    newDesign: true,
                    ref: createRef(),
                    isFirst: false,
                },
                {
                    name: "MICROFLOW",
                    description: `
                    MicroFlow Mobile is a high-performance, native barcode-scanner client application built for the Microflow Warehouse Management System (WMS). Designed to optimize warehouse operations, the app handles core logistics workflows including inventory tracking, goods receiving, and real-time stock scanning.

                    The application is structured around a strict 4-layer architecture to maintain modularity, testability, and a clear separation of concerns:
                    - Application Layer: Contains core business entities and use case definitions with zero implementation logic.
                    - Data Layer: Houses use case implementations, repositories, mappers, and remote data source interfaces (xDataSourceRemote).
                    - Framework Layer: Manages external integrations, including the centralized ApiService for backend communication, remote data gateways, and Keycloak authentication workflows.

                    Technical Stack & Highlights
                    - Framework: Flutter / Dart
                    - State & Dependency Management: GetIt service locator for explicit wiring of use cases, gateways, mappers, and presentation classes.
                    - Authentication & Security: Integrated with Keycloak OAuth2/OIDC protocols (microflow-mobile client configuration) supporting custom tenant mappers.
                    - Networking & Environment: Communicates with sibling microservice backends and containerized identity providers orchestrated via Docker environments.
                    `,  
                    images: [microflow1, microflow2, microflow3, microflow4], 
                    imageIndex: 0,
                    tehnologies: ["Flutter", "Dart", "Keycloak", "Docker", "Layered architecture" ], 
                    newDesign: false,
                    ref: createRef(),
                },
                {
                    name: "PROTOCOL CARD",
                    description: `
                    Protocol Card is a modern, privacy-focused digital business card application designed to make networking effortless, fast, and reliable. Built using Clean Architecture principles, it ensures robust offline functionality alongside seamless remote synchronization.

                    Key Features & Functionality
                    - Instant Contact Sharing: Generate dynamic QR codes containing your professional profile details, including name, business title, email, phone number, website, and social links like LinkedIn.
                    - Offline-First Reliability: Powered by local caching layers and a combined data source pattern, your card information remains fully accessible and shareable even without an internet connection.
                    - Seamless Remote Sync: Automatically synchronizes details and settings when connectivity is restored, utilizing Supabase backend services and local secure storage.
                    - Customizable Presentation: Easily update personal details, switch themes, fonts, and manage display configurations directly through dedicated settings screens.
                    `,  
                    images: [protocol1, protocol2, protocol3, protocol4, protocol5], 
                    imageIndex: 0,
                    tehnologies: ["Google Play", "Apple Store", "Supabase", "Clean Architecture", "Offline-first design" ], 
                    url: "https://play.google.com/store/apps/details?id=com.binaryfusion.dcm.digital_card_mobile&hl=en_US" ,
                    newDesign: false,
                    ref: createRef(),
                },
                {
                    name: "E-BLOC ANDROID APP",
                    description: "We designed and developed a core Android application that seamlessly integrates with its related system components. Our team was responsible for the complete interface design and functionality implementation, delivering a solution precisely tailored to requirements.", 
                    images: [ebloc1, ebloc2, ebloc3, ebloc4], 
                    imageIndex: 0,
                    tehnologies: ["Android", "Java", "MySql", "API", "Retrofit" ], 
                    url: "https://play.google.com/store/apps/details?id=com.xisoft.ebloc.ro" ,
                    newDesign: true,
                    ref: createRef(),
                },
                {
                    name: "ART MEDICA",
                    description: "Cross-platform healthcare application using Flutter, ensuring seamless performance on both Android and iOS. This solution leverages Firebase for secure authentication (including social logins) and Firestore for flexible, scalable data storage. The architecture adheres strictly to Clean Architecture principles, guaranteeing superior maintainability and testability.",
                    images: [artmedica1, artmedica2, artmedica3],
                    imageIndex: 0,
                    tehnologies: ["Flutter", "Dart", "Firebase", "Firestore", "Clean architecture"],
                    url: "https://play.google.com/store/apps/details?id=com.binaryfusion.ars_medica",
                    newDesign: true,
                    ref: createRef(),
                },
                {
                    name: "TAMATO",
                    description: "Comprehensive mobile ticketing management application from the ground up, featuring robust QR code generation and scanning capabilities. This project allowed us to create a resilient and maintainable architecture, designed for seamless integration of future enhancements and unplanned feature expansions.",
                    images: [tamato1, tamato2, tamato3],
                    imageIndex: 0,
                    tehnologies: ["Flutter", "Dart", "API Integration", "QR Code", "Clean Architecture", "Layered Architecture"],
                    newDesign: true,
                    ref: createRef(),
                },
                {
                    name: "WEB APP WITH REACT AND GO LANG ON AWS",
                    description: "This is a web application that makes use of multiple AWS components. It is a case study project with a React front end  on AWS Amplify. Requests are processed by a Lambda function that runs a Go lang code inside a Docker container on ECR. For the database it is also using AWS services in the form of a Dynamo database.",
                    images: [gowebapp],
                    imageIndex: 0,
                    tehnologies: ["Go lang", "ReactJs", "Docker", "AWS Lambda", "AWS API Gateway", "Clean architecture"],
                    url: "https://www.binaryfusion.ro/dp-golang-webapp-ecr",
                    ref: createRef(),
                },
                {
                    name: "CLIMBING TIMER",
                    description: "Flutter-powered mobile application with offline capabilites. By leveraging a local SQLite database, the app ensures seamless offline data access and persistence, so users can always view and manage their information. To transform raw data into actionable insights, we've integrated fl_charts, providing clear, dynamic, and intuitive data visualizations that bring complex information to life.",
                    images: [timer1, timer2],
                    imageIndex: 0,
                    tehnologies: ["Flutter", "Dart", "SQL", "Data visualisation", "Supabase", "Offline persistence"],
                    newDesign: true,
                    url: "https://play.google.com/store/apps/details?id=com.binaryfusion.ro.timer_app&hl=en",
                    ref: createRef(),
                },
                {
                    name: "MTG PROXY",
                    description: "Highly responsive website using ReactJs framework. Showscases the integration of a static website hosted on Bitbucket with Netlify for automatic build system.",
                    images: [mtg1, mtg2],
                    imageIndex: 0,
                    tehnologies: ["React", "Javascript", "Mobile design", "Responsive design", "Netlify"],
                    url: "https://mtgproxyshop.com/",
                    ref: createRef(),
                    newDesign: true,
                },
                {
                    name: "RATEMY",
                    description: "A cross-platform mobile application built with Flutter, delivering a user experience reminiscent of Instagram. Features include real-time UI updates powered by Firebase and a customizable rating widget for enhanced user interaction",
                    images: [ratemy1, ratemy2, ratemy3, ratemy4],
                    imageIndex: 0,
                    tehnologies: ["Flutter", "Dart", "Firebase", "Clean Architecture",],
                    // url: ""
                    ref: createRef(),
                },
                { 
                    name: "CAUTARE DOSARE", 
                    description: "Facilitates the search for court cases. It offers a friendly interface, optimized for various types of devices. It is designed to monitor searches and cases chosen by the user and to send email notifications or to the registered account in the application.", 
                    images: [cautaredosare, cautaredosare2, cautaredosare3], 
                    imageIndex: 0,
                    tehnologies: ["Angular", "Python", "Flask", "Docker", "MongoDb", "Nginx" ], 
                    ref: createRef(),
                },
                {
                    name: "LICITATII.RO", 
                    description: "Collects information about land offers on auction during the foreclosure process. Announcements are collected from banks, specialized platforms and mayor's offices. By comparing with current prices for similar goods, an overview is provided to get the best choice in case of an investment. The collected data is displayed in an interface designed to increase efficiency and decrease search time. It gets the data as a web page scrapper.", 
                    images: [licitatii], 
                    imageIndex: 0,
                    tehnologies: ["React", "Python", "Flask", "MySql", "Pytesseract", "Reportlab" ], 
                    url: "https://licitatii.binaryfusion.ro",
                    newDesign: true,
                    ref: createRef(),
                },
                {
                    name: "GCP ARHITECTURE SETUP MODEL", 
                    description: "Google Cloud Platform (GCP) project setup as a study case, meticulously exploring the interplay of various cloud components. This initiative involved developing a Go-based GCP service seamlessly connected to a serverless MongoDB Atlas instance. The front end was crafted using Next.js, and to ensure full reusability for future projects, we integrated a robust user management system via Firebase Authentication on both the client and server sides.", 
                    images: [gcp], 
                    imageIndex: 0,
                    tehnologies: [ "Go", "Google Cloud Run", "NextJs", "Firebase", "Docker", "MongoDb Serverless" ], 
                    url: "https://bropromotionals-front-end-test-mve3otjx7-h2wkbw94-binaryfusion.vercel.app/",
                    ref: createRef(),
                },
                {
                    name: "CAR JOIN",
                    description: "Flutter cross-platform app with google maps integraton. Android and Ios app that uses Supabase services for user authentication, database, storage and notifications to help travelers organize the cars on their trips. My contribution on this project was to establish and implement strong Clean Architecture and be a part of the development team",
                    images: [carjoin4, carjoin1, carjoin2, carjoin3],
                    imageIndex: 0,
                    tehnologies: ["Flutter", "Dart", "Supabase", "MySql", "Clean Architecture", "Google Maps"],
                    // url: ""
                    ref: createRef(),
                },
                {
                    name: "STUDY - RUST COMMAND LINE APP", 
                    description: "Hierarchical mind mapping text based application tool. Organize thoughts and ideas in the process of understanding a new concept. Forces you to divide the toughs in categories: questions, model, documentation, term and try. Organize the nodes in a hierarchical order. You can navigate between nodes and add documentation and labels.", 
                    images: [study], 
                    imageIndex: 0,
                    tehnologies: ["Rust", "MySql", "Docker", "Scripting" ], 
                    url: "https://github.com/lupascugabrielcristian/studyapp",
                    ref: createRef(),
                }
            ]
        };
    }


    sendEvent = () => {
        if(window.location.hostname === 'localhost' || window.location.hostname.indexOf('192.168.0') === 0) {
            return;
        }

        if(!sessionStorage.getItem('case-studies')) {
            sessionStorage.setItem('case-studies', true);

            fetch('https://api.ipify.org?format=json')
                .then((ipResp) => ipResp.json().then((ipJson) => {
                    fetch('https://09mclyfv7k.execute-api.eu-central-1.amazonaws.com/prod/log_event', {
                        method: 'POST',
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({type: 'projects', name: 'binaryfusion.ro', from: ipJson}),
                    }).then((response) => response.json().then((responseData) => {
                        sessionStorage.setItem('success', responseData.EventId);
                    }));
                })
            );
        }
    }

    showImage(project) {
        this.setState({
            preview: {
                project: project,
                imageIndex: project.imageIndex,
                image: project.images[project.imageIndex]
            }
        });
    }

    hideImage(proj, lastIndex) {
        this.setState({
            preview: {
                project: null,
                imageIndex: 0,
                image: null
            },
        });
        proj.ref.current.updateImage(lastIndex);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        
        this.sendEvent();

        const head = document.head;
        const url = `https://www.binaryfusion.ro/case-studies`;

        // Check if a canonical link already exists
        let link = document.querySelector("link[rel='canonical']");

        if (link) {
            // Update existing link
            link.setAttribute("href", url);
        } else {
            // Create a new link element
            link = document.createElement("link");
            link.setAttribute("rel", "canonical");
            link.setAttribute("href", url);
            head.appendChild(link);
        }
    }

    render() {


        return (
            <div id="all-sections" className='section-background-2'>
                <Header className='with-bottom-border-1 grey-section-background'/>

                <PageTitle title={'Projects portfolio'}
                           subtitle={"Explore our portfolio of previous projects and in-depth case studies to see how we've helped businesses like yours achieve their goals. See what's possible when you partner with us."}
                           className="grey-section-background"
                />

                <div className='extr-band grey-section-background' />

                <div className="flex-column-centered section" > 

                    { this.state.projects.map( (proj, index) => <Project ref={proj.ref} key={index} project={proj} onShowPreview={() => this.showImage(proj)} /> )}

                    <div className='mb-6'/>

                </div>

                <BannerSection />

                <Footer />

                {this.state.preview.image != null && 
                    <ImagePreview preview={this.state.preview} closeFc={(proj, lastIndex) => this.hideImage(proj, lastIndex)} />}
                
            </div>
        );

    }
}

export default CaseStudies;
